<template>
  <div class="home_footer">
    <div v-if="this.$lang() == 4 && this.checkGeneralEnvironment() == 4">
      <div class="home_footer_tdmu">
        <div class="foot-logo">
         <div class="logos">
            <img
               src="/static/images/logo-jp.png"
               class="logo_top"
               @click="goHome()"
            />
            <a href="http://online.gov.vn/Home/WebDetails/92029"
               ><img
               alt=""
               title=""
               class="logo_top"
               src="/static/images/logoSaleNoti.png"
            /></a>
         </div>
         <div class="foot-info">
            <div class="main-info">
               <div class="block-info">
               <p class="company">CÔNG TY TNHH TECHZEN</p>
               </div>
               <div class="block-info">
               <img src="/static/images/site.png" vspace="30" alt="" />
               <p>
                  Tầng 10, CVPM, 02 Quang Trung, P.Thạch Thang, Q.Hải Châu, TP.Đà
                  Nẵng
               </p>
               </div>
               <div class="block-info">
               <img src="/static/images/tax.png" vspace="30" alt="" />
               <p>MST: 0402131940 Sở KT & ĐT Tp..Đà Nẵng cấp ngày 14/01/2022</p>
               </div>
               <div class="block-info">
               <img src="/static/images/phone.png" vspace="30" alt="" />
               <p>0236 6281189</p>
               </div>
               <div class="block-info">
               <img src="/static/images/email2.png" vspace="30" alt="" />
               <p>studyarts-contact@techzen.vn</p>
               </div>
            </div>
         </div>
        </div>
        <div class="footer-icon">
          <div class="home_footer3">
            <div>
              <img
                src="/static/images/Frame 56.png"
                alt="/"
                @click="redirectFooter('operation')"
              />
              <span
                style="display: block; color: rgb(204, 204, 204)"
                @click="redirectFooter('operation')"
                >{{ $t("home.operation") }}</span
              >
            </div>
          </div>
          <div class="home_footer3">
            <div>
              <img
                src="/static/images/conversation 1.png"
                alt="/"
                @click="redirectFooter('faq')"
              />
              <span
                style="display: block; color: rgb(204, 204, 204)"
                @click="redirectFooter('faq')"
                >{{ $t("home.faq") }}</span
              >
            </div>
          </div>
          <div class="home_footer3">
            <div>
              <img
                src="/static/images/file 1.png"
                alt="/"
                @click="redirectFooter('protocol')"
              />
              <span
                style="display: block; color: rgb(204, 204, 204)"
                @click="redirectFooter('protocol')"
                >{{ $t("home.service") }}</span
              >
            </div>
          </div>
          <div class="home_footer3">
            <div>
              <img
                class="security"
                src="/static/images/Frame 57.png"
                alt="/"
                @click="redirectFooter('policy')"
              />
              <span
                style="display: block; color: rgb(204, 204, 204)"
                @click="redirectFooter('policy')"
                >{{ $t("home.policy") }}</span
              >
            </div>
          </div>
          <div class="home_footer3">
            <div>
              <img
                src="/static/images/contract 1.png"
                alt="/"
                @click="goContract()"
              />
              <span
                style="display: block; color: rgb(204, 204, 204)"
                @click="goContract()"
                >Hợp đồng dịch vụ</span
              >
            </div>
          </div>
          <div class="home_footer3">
            <div>
              <img
                src="/static/images/packing-list 1.png"
                alt="/"
                @click="goExchange()"
              />
              <span
                style="display: block; color: rgb(204, 204, 204)"
                @click="goExchange()"
                >Chính sách giao nhận</span
              >
            </div>
          </div>
        </div>
      </div>
    </div>
   
    <div v-else>
      <div class="home_footer2">
        <!-- <div class="foot-logo">
        <img src="/static/images/logo.png" class="logo_top" @click="goHome" />
      </div> -->
        <div class="footer-icon">
          <div class="home_footer3">
            <div>
              <img
                src="/static/images/home_opre.png"
                alt="/"
                @click="redirectFooter('operation')"
              />
              <span
                style="display: block; color: rgb(204, 204, 204)"
                @click="redirectFooter('operation')"
                >{{ $t("home.operation") }}</span
              >
            </div>
          </div>
          <div class="home_footer3">
            <div>
              <img
                src="/static/images/home_faq.png"
                alt="/"
                @click="redirectFooter('faq')"
              />
              <span
                style="display: block; color: rgb(204, 204, 204)"
                @click="redirectFooter('faq')"
                >{{ $t("home.faq") }}</span
              >
            </div>
          </div>
          <div class="home_footer3">
            <div>
              <img
                src="/static/images/home_service.png"
                alt="/"
                @click="redirectFooter('protocol')"
              />
              <span
                style="display: block; color: rgb(204, 204, 204)"
                @click="redirectFooter('protocol')"
                >{{ $t("home.service") }}</span
              >
            </div>
          </div>
          <div class="home_footer3">
            <div>
              <img
                src="/static/images/home_policy.png"
                alt="/"
                @click="redirectFooter('policy')"
              />
              <span
                style="display: block; color: rgb(204, 204, 204)"
                @click="redirectFooter('policy')"
                >{{ $t("home.policy") }}</span
              >
            </div>
          </div>
        </div>
      </div>
      <div class="foot-copyright">©Ad-Sol Asia Corporation</div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  methods: {
    redirectFooter: function(str) {
      this.$emit("redirectFooter", str);
    },
    goHome: function() {
      this.$router.push({
        path: "/"
      });
    },
    goExchange() {
      this.$router.push({
        path: "/home/exchange"
      });
    },
    goContract() {
      this.$router.push({
        path: "/home/contract_new"
      });
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.home_footer {
  font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
  background-color: #033C7F !important;
}
.home_footer1 {
  padding: 30px 0px;
  max-width: 1200px;
  min-width: 580px;
  width: calc(100% - 60px);
  margin: 0 auto;
  display: flex;
}
.home_footer1 .dv1 {
  border-top: 2px solid #fff;
  width: 141px;
  margin-bottom: 15px;
}
.home_footer1 .dv2 {
  border-top: 2px solid #fff;
  width: 108px;
  margin-bottom: 15px;
}
.home_footer1 .foot-logo {
  width: 300px;
}
.home_footer1 .foot-logo img {
  height: auto !important;
  width: 150px;
}
.home_footer1 .foot-info {
  width: 600px;
  padding: 10px 30px;
}
.home_footer1 .foot-info .main-info {
  padding: 5px 0px;
}
.home_footer1 .foot-info img {
  display: inline-block;
  vertical-align: sub;
  width: 17px;
  height: 17px;
  margin-right: 5px;
}
.home_footer1 .title h3 {
  padding-bottom: 10px;
  color: #fff;
  font-size: 18px;
}
.home_footer1 .foot-info .block-info {
  display: flex;
}
.home_footer1 .foot-info p {
  padding-bottom: 15px;
  color: #fff;
  font-size: 14px;
  display: inline-block;
}
.home_footer1 .footer-icon {
  display: block !important;
  width: 300px;
}
.home_footer1 .home_footer3 {
  text-align: left;
  margin: 0px;
  line-height: 30px;
}
/* .foot-copyright{
  height: 50px;
  line-height: 50px;
  background-color: #161919;
  color: #797979;
} */
/* tdmu footer */
.home_footer_tdmu {
  padding: 30px 0px;
  max-width: 1200px;
  min-width: 580px;
  width: calc(100% - 60px);
  margin: 0 auto;
  display: flex;
}
.home_footer_tdmu .dv1 {
  border-top: 2px solid #fff;
  width: 141px;
  margin-bottom: 15px;
}
.home_footer_tdmu .dv2 {
  border-top: 2px solid #fff;
  width: 108px;
  margin-bottom: 15px;
}
.home_footer_tdmu .foot-logo {
  width: 50%;
}
.home_footer_tdmu .foot-logo .logos{
   display: flex;
   margin-left: 30px;
   align-items: center;
}
.home_footer_tdmu .foot-logo .logos a{
   padding-left: 15px;
}
.home_footer_tdmu .foot-logo img {
  height: auto !important;
  width: 150px;
  margin:0;
}
.home_footer_tdmu .foot-info {
  width: 600px;
  padding: 10px 30px;
}
.home_footer_tdmu .foot-info .main-info {
  padding: 5px 0px;
}
.home_footer_tdmu .foot-info img {
  display: inline-block;
  vertical-align: sub;
  width: 17px;
  height: 17px !important;
  margin-right: 5px;
}
.home_footer_tdmu .title h3 {
  padding-bottom: 10px;
  color: #fff;
  font-size: 18px;
}
.home_footer_tdmu .foot-info .block-info {
  display: flex;
}
.home_footer_tdmu .foot-info p {
  padding-bottom: 15px;
  color: #fff;
  font-size: 14px;
  display: inline-block;
}
.home_footer_tdmu .foot-info .company{
   font-size: 18px;
}
.home_footer_tdmu .footer-icon {
  display: flex !important;
  width: 50%;
  flex-wrap: wrap;
  justify-content: center;
}
.home_footer_tdmu .footer-icon .home_footer3{
   width: 30% !important;
}
.home_footer_tdmu .footer-icon .home_footer3 img{
   display:block !important;
   margin: 5px auto;
   width: 40px;
}
.home_footer_tdmu .footer-icon .home_footer3 .security{
   width:30px;
}
</style>



// WEBPACK FOOTER //
// src/views/footer/footer.vue